var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"askingTop"},[_c('img',{attrs:{"src":require("../assets/image/my.png"),"alt":""}}),_c('div',{staticClass:"getAsking"},[_vm._v(_vm._s(_vm.ptitle))])])
}
var staticRenderFns = []

export { render, staticRenderFns }